import React from 'react';
import styled from 'styled-components';

import { ScrollBox } from './scroll-box';
import { Canvas } from './canvas';
import { Wltp } from './wltp';
import { HeadlineComponent } from './headline';
import { InitialState } from '../FeatureAppTypes';
import { useTrackingManager } from '../context/useTrackingManager';

const Background = styled.div`
  background-color: ${({ color }) => color};
`;

const Container = styled.div`
  position: relative;
`;

export const Animated: React.FC<InitialState> = ({
  additionalText,
  backdropSpeed,
  animation,
  wltp,
  themeScroll,
  themeWltp,
}: InitialState) => {
  const trackingManager = useTrackingManager();

  // listen to position
  const [position, setPosition] = React.useState(0);

  // only trigger tracking events once
  const [alreadyTracked, setAlreadyTracked] = React.useState(false);

  React.useEffect(() => {
    if (alreadyTracked) return;
    // only trigger reach end of module if at least 97% have been scrolled
    if (position >= 0.97) {
      setAlreadyTracked(true);
      trackingManager.reachEndOfModule();
    }
  }, [position]);

  const bgColor = themeScroll.colors.colorCanvas200;

  return (
    <Background color={bgColor}>
      <Container color={bgColor}>
        <HeadlineComponent
          position={position}
          headlines={animation.headlines}
          theme={themeScroll}
        />
        <ScrollBox outerHeight="150vh" innerHeight="100vh" onScroll={setPosition}>
          <Canvas
            position={position}
            backdropSpeed={backdropSpeed}
            animation={animation}
            theme={themeScroll}
          />
        </ScrollBox>
        {wltp.length > 0 || additionalText ? (
          <Wltp wltp={wltp} additionalText={additionalText} themeWltp={themeWltp} />
        ) : undefined}
      </Container>
    </Background>
  );
};
